import React from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import styled from "styled-components";

interface LayoutProps {
  children: any;
  height?: string;
}

const Layout: React.FC<LayoutProps> = ({ children, height }) => {
  return (
    <>
      <StyledLayout $height={height}>
        <Content>{children}</Content>
      </StyledLayout>
    </>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;

const StyledLayout = styled(Box)<{ $height?: string }>`
  width: 35%;
  margin: 1rem auto;
  padding: 2rem;
  border: 1px solid #e8eaed;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  background-color: #ffffff;
  position: relative;
  overflow-y: auto;
  height: ${({ $height }) => $height};
  box-sizing: border-box;
  @media screen and (max-width: 767px) {
    width: 90%;
  }
  @media screen and (min-width: 768px) and (max-width: 1023px) {
    width: 50%;
  }
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;
